/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SwitchField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createEntertainment } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function EntertainmentCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    actors: "",
    awards: "",
    boxOffice: "",
    country: "",
    director: "",
    dvd: "",
    genre: [],
    imdbId: "",
    imdbRating: "",
    imdbVotes: "",
    language: "",
    metaScore: "",
    plot: "",
    poster: "",
    production: "",
    rated: "",
    released: "",
    runtime: "",
    title: "",
    rottenTomatoConsensus: "",
    rottenTomatoFresh: "",
    rottenTomatoImage: "",
    rottenTomatoMeter: "",
    rottenTomatoRating: "",
    rottenTomatoReviews: "",
    rottenTomatoRotten: "",
    rottenTomatoUrl: "",
    rottenTomatoUserMeter: "",
    rottenTomatoUserRating: "",
    rottenTomatoUserReviews: "",
    type: "",
    website: "",
    writer: "",
    year: "",
    contentType: "",
    isActive: false,
  };
  const [actors, setActors] = React.useState(initialValues.actors);
  const [awards, setAwards] = React.useState(initialValues.awards);
  const [boxOffice, setBoxOffice] = React.useState(initialValues.boxOffice);
  const [country, setCountry] = React.useState(initialValues.country);
  const [director, setDirector] = React.useState(initialValues.director);
  const [dvd, setDvd] = React.useState(initialValues.dvd);
  const [genre, setGenre] = React.useState(initialValues.genre);
  const [imdbId, setImdbId] = React.useState(initialValues.imdbId);
  const [imdbRating, setImdbRating] = React.useState(initialValues.imdbRating);
  const [imdbVotes, setImdbVotes] = React.useState(initialValues.imdbVotes);
  const [language, setLanguage] = React.useState(initialValues.language);
  const [metaScore, setMetaScore] = React.useState(initialValues.metaScore);
  const [plot, setPlot] = React.useState(initialValues.plot);
  const [poster, setPoster] = React.useState(initialValues.poster);
  const [production, setProduction] = React.useState(initialValues.production);
  const [rated, setRated] = React.useState(initialValues.rated);
  const [released, setReleased] = React.useState(initialValues.released);
  const [runtime, setRuntime] = React.useState(initialValues.runtime);
  const [title, setTitle] = React.useState(initialValues.title);
  const [rottenTomatoConsensus, setRottenTomatoConsensus] = React.useState(
    initialValues.rottenTomatoConsensus
  );
  const [rottenTomatoFresh, setRottenTomatoFresh] = React.useState(
    initialValues.rottenTomatoFresh
  );
  const [rottenTomatoImage, setRottenTomatoImage] = React.useState(
    initialValues.rottenTomatoImage
  );
  const [rottenTomatoMeter, setRottenTomatoMeter] = React.useState(
    initialValues.rottenTomatoMeter
  );
  const [rottenTomatoRating, setRottenTomatoRating] = React.useState(
    initialValues.rottenTomatoRating
  );
  const [rottenTomatoReviews, setRottenTomatoReviews] = React.useState(
    initialValues.rottenTomatoReviews
  );
  const [rottenTomatoRotten, setRottenTomatoRotten] = React.useState(
    initialValues.rottenTomatoRotten
  );
  const [rottenTomatoUrl, setRottenTomatoUrl] = React.useState(
    initialValues.rottenTomatoUrl
  );
  const [rottenTomatoUserMeter, setRottenTomatoUserMeter] = React.useState(
    initialValues.rottenTomatoUserMeter
  );
  const [rottenTomatoUserRating, setRottenTomatoUserRating] = React.useState(
    initialValues.rottenTomatoUserRating
  );
  const [rottenTomatoUserReviews, setRottenTomatoUserReviews] = React.useState(
    initialValues.rottenTomatoUserReviews
  );
  const [type, setType] = React.useState(initialValues.type);
  const [website, setWebsite] = React.useState(initialValues.website);
  const [writer, setWriter] = React.useState(initialValues.writer);
  const [year, setYear] = React.useState(initialValues.year);
  const [contentType, setContentType] = React.useState(
    initialValues.contentType
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setActors(initialValues.actors);
    setAwards(initialValues.awards);
    setBoxOffice(initialValues.boxOffice);
    setCountry(initialValues.country);
    setDirector(initialValues.director);
    setDvd(initialValues.dvd);
    setGenre(initialValues.genre);
    setCurrentGenreValue("");
    setImdbId(initialValues.imdbId);
    setImdbRating(initialValues.imdbRating);
    setImdbVotes(initialValues.imdbVotes);
    setLanguage(initialValues.language);
    setMetaScore(initialValues.metaScore);
    setPlot(initialValues.plot);
    setPoster(initialValues.poster);
    setProduction(initialValues.production);
    setRated(initialValues.rated);
    setReleased(initialValues.released);
    setRuntime(initialValues.runtime);
    setTitle(initialValues.title);
    setRottenTomatoConsensus(initialValues.rottenTomatoConsensus);
    setRottenTomatoFresh(initialValues.rottenTomatoFresh);
    setRottenTomatoImage(initialValues.rottenTomatoImage);
    setRottenTomatoMeter(initialValues.rottenTomatoMeter);
    setRottenTomatoRating(initialValues.rottenTomatoRating);
    setRottenTomatoReviews(initialValues.rottenTomatoReviews);
    setRottenTomatoRotten(initialValues.rottenTomatoRotten);
    setRottenTomatoUrl(initialValues.rottenTomatoUrl);
    setRottenTomatoUserMeter(initialValues.rottenTomatoUserMeter);
    setRottenTomatoUserRating(initialValues.rottenTomatoUserRating);
    setRottenTomatoUserReviews(initialValues.rottenTomatoUserReviews);
    setType(initialValues.type);
    setWebsite(initialValues.website);
    setWriter(initialValues.writer);
    setYear(initialValues.year);
    setContentType(initialValues.contentType);
    setIsActive(initialValues.isActive);
    setErrors({});
  };
  const [currentGenreValue, setCurrentGenreValue] = React.useState("");
  const genreRef = React.createRef();
  const validations = {
    actors: [],
    awards: [],
    boxOffice: [],
    country: [],
    director: [],
    dvd: [],
    genre: [],
    imdbId: [],
    imdbRating: [],
    imdbVotes: [],
    language: [],
    metaScore: [],
    plot: [],
    poster: [],
    production: [],
    rated: [],
    released: [],
    runtime: [],
    title: [],
    rottenTomatoConsensus: [],
    rottenTomatoFresh: [],
    rottenTomatoImage: [],
    rottenTomatoMeter: [],
    rottenTomatoRating: [],
    rottenTomatoReviews: [],
    rottenTomatoRotten: [],
    rottenTomatoUrl: [],
    rottenTomatoUserMeter: [],
    rottenTomatoUserRating: [],
    rottenTomatoUserReviews: [],
    type: [],
    website: [],
    writer: [],
    year: [],
    contentType: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          actors,
          awards,
          boxOffice,
          country,
          director,
          dvd,
          genre,
          imdbId,
          imdbRating,
          imdbVotes,
          language,
          metaScore,
          plot,
          poster,
          production,
          rated,
          released,
          runtime,
          title,
          rottenTomatoConsensus,
          rottenTomatoFresh,
          rottenTomatoImage,
          rottenTomatoMeter,
          rottenTomatoRating,
          rottenTomatoReviews,
          rottenTomatoRotten,
          rottenTomatoUrl,
          rottenTomatoUserMeter,
          rottenTomatoUserRating,
          rottenTomatoUserReviews,
          type,
          website,
          writer,
          year,
          contentType,
          isActive,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createEntertainment.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "EntertainmentCreateForm")}
      {...rest}
    >
      <TextField
        label="Actors"
        isRequired={false}
        isReadOnly={false}
        value={actors}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors: value,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.actors ?? value;
          }
          if (errors.actors?.hasError) {
            runValidationTasks("actors", value);
          }
          setActors(value);
        }}
        onBlur={() => runValidationTasks("actors", actors)}
        errorMessage={errors.actors?.errorMessage}
        hasError={errors.actors?.hasError}
        {...getOverrideProps(overrides, "actors")}
      ></TextField>
      <TextField
        label="Awards"
        isRequired={false}
        isReadOnly={false}
        value={awards}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards: value,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.awards ?? value;
          }
          if (errors.awards?.hasError) {
            runValidationTasks("awards", value);
          }
          setAwards(value);
        }}
        onBlur={() => runValidationTasks("awards", awards)}
        errorMessage={errors.awards?.errorMessage}
        hasError={errors.awards?.hasError}
        {...getOverrideProps(overrides, "awards")}
      ></TextField>
      <TextField
        label="Box office"
        isRequired={false}
        isReadOnly={false}
        value={boxOffice}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice: value,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.boxOffice ?? value;
          }
          if (errors.boxOffice?.hasError) {
            runValidationTasks("boxOffice", value);
          }
          setBoxOffice(value);
        }}
        onBlur={() => runValidationTasks("boxOffice", boxOffice)}
        errorMessage={errors.boxOffice?.errorMessage}
        hasError={errors.boxOffice?.hasError}
        {...getOverrideProps(overrides, "boxOffice")}
      ></TextField>
      <TextField
        label="Country"
        isRequired={false}
        isReadOnly={false}
        value={country}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country: value,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.country ?? value;
          }
          if (errors.country?.hasError) {
            runValidationTasks("country", value);
          }
          setCountry(value);
        }}
        onBlur={() => runValidationTasks("country", country)}
        errorMessage={errors.country?.errorMessage}
        hasError={errors.country?.hasError}
        {...getOverrideProps(overrides, "country")}
      ></TextField>
      <TextField
        label="Director"
        isRequired={false}
        isReadOnly={false}
        value={director}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director: value,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.director ?? value;
          }
          if (errors.director?.hasError) {
            runValidationTasks("director", value);
          }
          setDirector(value);
        }}
        onBlur={() => runValidationTasks("director", director)}
        errorMessage={errors.director?.errorMessage}
        hasError={errors.director?.hasError}
        {...getOverrideProps(overrides, "director")}
      ></TextField>
      <TextField
        label="Dvd"
        isRequired={false}
        isReadOnly={false}
        value={dvd}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd: value,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.dvd ?? value;
          }
          if (errors.dvd?.hasError) {
            runValidationTasks("dvd", value);
          }
          setDvd(value);
        }}
        onBlur={() => runValidationTasks("dvd", dvd)}
        errorMessage={errors.dvd?.errorMessage}
        hasError={errors.dvd?.hasError}
        {...getOverrideProps(overrides, "dvd")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre: values,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            values = result?.genre ?? values;
          }
          setGenre(values);
          setCurrentGenreValue("");
        }}
        currentFieldValue={currentGenreValue}
        label={"Genre"}
        items={genre}
        hasError={errors?.genre?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("genre", currentGenreValue)
        }
        errorMessage={errors?.genre?.errorMessage}
        setFieldValue={setCurrentGenreValue}
        inputFieldRef={genreRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Genre"
          isRequired={false}
          isReadOnly={false}
          value={currentGenreValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.genre?.hasError) {
              runValidationTasks("genre", value);
            }
            setCurrentGenreValue(value);
          }}
          onBlur={() => runValidationTasks("genre", currentGenreValue)}
          errorMessage={errors.genre?.errorMessage}
          hasError={errors.genre?.hasError}
          ref={genreRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "genre")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Imdb id"
        isRequired={false}
        isReadOnly={false}
        value={imdbId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId: value,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.imdbId ?? value;
          }
          if (errors.imdbId?.hasError) {
            runValidationTasks("imdbId", value);
          }
          setImdbId(value);
        }}
        onBlur={() => runValidationTasks("imdbId", imdbId)}
        errorMessage={errors.imdbId?.errorMessage}
        hasError={errors.imdbId?.hasError}
        {...getOverrideProps(overrides, "imdbId")}
      ></TextField>
      <TextField
        label="Imdb rating"
        isRequired={false}
        isReadOnly={false}
        value={imdbRating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating: value,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.imdbRating ?? value;
          }
          if (errors.imdbRating?.hasError) {
            runValidationTasks("imdbRating", value);
          }
          setImdbRating(value);
        }}
        onBlur={() => runValidationTasks("imdbRating", imdbRating)}
        errorMessage={errors.imdbRating?.errorMessage}
        hasError={errors.imdbRating?.hasError}
        {...getOverrideProps(overrides, "imdbRating")}
      ></TextField>
      <TextField
        label="Imdb votes"
        isRequired={false}
        isReadOnly={false}
        value={imdbVotes}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes: value,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.imdbVotes ?? value;
          }
          if (errors.imdbVotes?.hasError) {
            runValidationTasks("imdbVotes", value);
          }
          setImdbVotes(value);
        }}
        onBlur={() => runValidationTasks("imdbVotes", imdbVotes)}
        errorMessage={errors.imdbVotes?.errorMessage}
        hasError={errors.imdbVotes?.hasError}
        {...getOverrideProps(overrides, "imdbVotes")}
      ></TextField>
      <TextField
        label="Language"
        isRequired={false}
        isReadOnly={false}
        value={language}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language: value,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.language ?? value;
          }
          if (errors.language?.hasError) {
            runValidationTasks("language", value);
          }
          setLanguage(value);
        }}
        onBlur={() => runValidationTasks("language", language)}
        errorMessage={errors.language?.errorMessage}
        hasError={errors.language?.hasError}
        {...getOverrideProps(overrides, "language")}
      ></TextField>
      <TextField
        label="Meta score"
        isRequired={false}
        isReadOnly={false}
        value={metaScore}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore: value,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.metaScore ?? value;
          }
          if (errors.metaScore?.hasError) {
            runValidationTasks("metaScore", value);
          }
          setMetaScore(value);
        }}
        onBlur={() => runValidationTasks("metaScore", metaScore)}
        errorMessage={errors.metaScore?.errorMessage}
        hasError={errors.metaScore?.hasError}
        {...getOverrideProps(overrides, "metaScore")}
      ></TextField>
      <TextField
        label="Plot"
        isRequired={false}
        isReadOnly={false}
        value={plot}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot: value,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.plot ?? value;
          }
          if (errors.plot?.hasError) {
            runValidationTasks("plot", value);
          }
          setPlot(value);
        }}
        onBlur={() => runValidationTasks("plot", plot)}
        errorMessage={errors.plot?.errorMessage}
        hasError={errors.plot?.hasError}
        {...getOverrideProps(overrides, "plot")}
      ></TextField>
      <TextField
        label="Poster"
        isRequired={false}
        isReadOnly={false}
        value={poster}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster: value,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.poster ?? value;
          }
          if (errors.poster?.hasError) {
            runValidationTasks("poster", value);
          }
          setPoster(value);
        }}
        onBlur={() => runValidationTasks("poster", poster)}
        errorMessage={errors.poster?.errorMessage}
        hasError={errors.poster?.hasError}
        {...getOverrideProps(overrides, "poster")}
      ></TextField>
      <TextField
        label="Production"
        isRequired={false}
        isReadOnly={false}
        value={production}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production: value,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.production ?? value;
          }
          if (errors.production?.hasError) {
            runValidationTasks("production", value);
          }
          setProduction(value);
        }}
        onBlur={() => runValidationTasks("production", production)}
        errorMessage={errors.production?.errorMessage}
        hasError={errors.production?.hasError}
        {...getOverrideProps(overrides, "production")}
      ></TextField>
      <TextField
        label="Rated"
        isRequired={false}
        isReadOnly={false}
        value={rated}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated: value,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rated ?? value;
          }
          if (errors.rated?.hasError) {
            runValidationTasks("rated", value);
          }
          setRated(value);
        }}
        onBlur={() => runValidationTasks("rated", rated)}
        errorMessage={errors.rated?.errorMessage}
        hasError={errors.rated?.hasError}
        {...getOverrideProps(overrides, "rated")}
      ></TextField>
      <TextField
        label="Released"
        isRequired={false}
        isReadOnly={false}
        value={released}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released: value,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.released ?? value;
          }
          if (errors.released?.hasError) {
            runValidationTasks("released", value);
          }
          setReleased(value);
        }}
        onBlur={() => runValidationTasks("released", released)}
        errorMessage={errors.released?.errorMessage}
        hasError={errors.released?.hasError}
        {...getOverrideProps(overrides, "released")}
      ></TextField>
      <TextField
        label="Runtime"
        isRequired={false}
        isReadOnly={false}
        value={runtime}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime: value,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.runtime ?? value;
          }
          if (errors.runtime?.hasError) {
            runValidationTasks("runtime", value);
          }
          setRuntime(value);
        }}
        onBlur={() => runValidationTasks("runtime", runtime)}
        errorMessage={errors.runtime?.errorMessage}
        hasError={errors.runtime?.hasError}
        {...getOverrideProps(overrides, "runtime")}
      ></TextField>
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title: value,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Rotten tomato consensus"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoConsensus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus: value,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoConsensus ?? value;
          }
          if (errors.rottenTomatoConsensus?.hasError) {
            runValidationTasks("rottenTomatoConsensus", value);
          }
          setRottenTomatoConsensus(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoConsensus", rottenTomatoConsensus)
        }
        errorMessage={errors.rottenTomatoConsensus?.errorMessage}
        hasError={errors.rottenTomatoConsensus?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoConsensus")}
      ></TextField>
      <TextField
        label="Rotten tomato fresh"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoFresh}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh: value,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoFresh ?? value;
          }
          if (errors.rottenTomatoFresh?.hasError) {
            runValidationTasks("rottenTomatoFresh", value);
          }
          setRottenTomatoFresh(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoFresh", rottenTomatoFresh)
        }
        errorMessage={errors.rottenTomatoFresh?.errorMessage}
        hasError={errors.rottenTomatoFresh?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoFresh")}
      ></TextField>
      <TextField
        label="Rotten tomato image"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoImage}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage: value,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoImage ?? value;
          }
          if (errors.rottenTomatoImage?.hasError) {
            runValidationTasks("rottenTomatoImage", value);
          }
          setRottenTomatoImage(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoImage", rottenTomatoImage)
        }
        errorMessage={errors.rottenTomatoImage?.errorMessage}
        hasError={errors.rottenTomatoImage?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoImage")}
      ></TextField>
      <TextField
        label="Rotten tomato meter"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoMeter}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter: value,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoMeter ?? value;
          }
          if (errors.rottenTomatoMeter?.hasError) {
            runValidationTasks("rottenTomatoMeter", value);
          }
          setRottenTomatoMeter(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoMeter", rottenTomatoMeter)
        }
        errorMessage={errors.rottenTomatoMeter?.errorMessage}
        hasError={errors.rottenTomatoMeter?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoMeter")}
      ></TextField>
      <TextField
        label="Rotten tomato rating"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoRating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating: value,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoRating ?? value;
          }
          if (errors.rottenTomatoRating?.hasError) {
            runValidationTasks("rottenTomatoRating", value);
          }
          setRottenTomatoRating(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoRating", rottenTomatoRating)
        }
        errorMessage={errors.rottenTomatoRating?.errorMessage}
        hasError={errors.rottenTomatoRating?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoRating")}
      ></TextField>
      <TextField
        label="Rotten tomato reviews"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoReviews}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews: value,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoReviews ?? value;
          }
          if (errors.rottenTomatoReviews?.hasError) {
            runValidationTasks("rottenTomatoReviews", value);
          }
          setRottenTomatoReviews(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoReviews", rottenTomatoReviews)
        }
        errorMessage={errors.rottenTomatoReviews?.errorMessage}
        hasError={errors.rottenTomatoReviews?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoReviews")}
      ></TextField>
      <TextField
        label="Rotten tomato rotten"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoRotten}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten: value,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoRotten ?? value;
          }
          if (errors.rottenTomatoRotten?.hasError) {
            runValidationTasks("rottenTomatoRotten", value);
          }
          setRottenTomatoRotten(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoRotten", rottenTomatoRotten)
        }
        errorMessage={errors.rottenTomatoRotten?.errorMessage}
        hasError={errors.rottenTomatoRotten?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoRotten")}
      ></TextField>
      <TextField
        label="Rotten tomato url"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoUrl}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl: value,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoUrl ?? value;
          }
          if (errors.rottenTomatoUrl?.hasError) {
            runValidationTasks("rottenTomatoUrl", value);
          }
          setRottenTomatoUrl(value);
        }}
        onBlur={() => runValidationTasks("rottenTomatoUrl", rottenTomatoUrl)}
        errorMessage={errors.rottenTomatoUrl?.errorMessage}
        hasError={errors.rottenTomatoUrl?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoUrl")}
      ></TextField>
      <TextField
        label="Rotten tomato user meter"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoUserMeter}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter: value,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoUserMeter ?? value;
          }
          if (errors.rottenTomatoUserMeter?.hasError) {
            runValidationTasks("rottenTomatoUserMeter", value);
          }
          setRottenTomatoUserMeter(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoUserMeter", rottenTomatoUserMeter)
        }
        errorMessage={errors.rottenTomatoUserMeter?.errorMessage}
        hasError={errors.rottenTomatoUserMeter?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoUserMeter")}
      ></TextField>
      <TextField
        label="Rotten tomato user rating"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoUserRating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating: value,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoUserRating ?? value;
          }
          if (errors.rottenTomatoUserRating?.hasError) {
            runValidationTasks("rottenTomatoUserRating", value);
          }
          setRottenTomatoUserRating(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoUserRating", rottenTomatoUserRating)
        }
        errorMessage={errors.rottenTomatoUserRating?.errorMessage}
        hasError={errors.rottenTomatoUserRating?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoUserRating")}
      ></TextField>
      <TextField
        label="Rotten tomato user reviews"
        isRequired={false}
        isReadOnly={false}
        value={rottenTomatoUserReviews}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews: value,
              type,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rottenTomatoUserReviews ?? value;
          }
          if (errors.rottenTomatoUserReviews?.hasError) {
            runValidationTasks("rottenTomatoUserReviews", value);
          }
          setRottenTomatoUserReviews(value);
        }}
        onBlur={() =>
          runValidationTasks("rottenTomatoUserReviews", rottenTomatoUserReviews)
        }
        errorMessage={errors.rottenTomatoUserReviews?.errorMessage}
        hasError={errors.rottenTomatoUserReviews?.hasError}
        {...getOverrideProps(overrides, "rottenTomatoUserReviews")}
      ></TextField>
      <TextField
        label="Type"
        isRequired={false}
        isReadOnly={false}
        value={type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type: value,
              website,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.type ?? value;
          }
          if (errors.type?.hasError) {
            runValidationTasks("type", value);
          }
          setType(value);
        }}
        onBlur={() => runValidationTasks("type", type)}
        errorMessage={errors.type?.errorMessage}
        hasError={errors.type?.hasError}
        {...getOverrideProps(overrides, "type")}
      ></TextField>
      <TextField
        label="Website"
        isRequired={false}
        isReadOnly={false}
        value={website}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website: value,
              writer,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.website ?? value;
          }
          if (errors.website?.hasError) {
            runValidationTasks("website", value);
          }
          setWebsite(value);
        }}
        onBlur={() => runValidationTasks("website", website)}
        errorMessage={errors.website?.errorMessage}
        hasError={errors.website?.hasError}
        {...getOverrideProps(overrides, "website")}
      ></TextField>
      <TextField
        label="Writer"
        isRequired={false}
        isReadOnly={false}
        value={writer}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer: value,
              year,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.writer ?? value;
          }
          if (errors.writer?.hasError) {
            runValidationTasks("writer", value);
          }
          setWriter(value);
        }}
        onBlur={() => runValidationTasks("writer", writer)}
        errorMessage={errors.writer?.errorMessage}
        hasError={errors.writer?.hasError}
        {...getOverrideProps(overrides, "writer")}
      ></TextField>
      <TextField
        label="Year"
        isRequired={false}
        isReadOnly={false}
        value={year}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year: value,
              contentType,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.year ?? value;
          }
          if (errors.year?.hasError) {
            runValidationTasks("year", value);
          }
          setYear(value);
        }}
        onBlur={() => runValidationTasks("year", year)}
        errorMessage={errors.year?.errorMessage}
        hasError={errors.year?.hasError}
        {...getOverrideProps(overrides, "year")}
      ></TextField>
      <TextField
        label="Content type"
        isRequired={false}
        isReadOnly={false}
        value={contentType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.contentType ?? value;
          }
          if (errors.contentType?.hasError) {
            runValidationTasks("contentType", value);
          }
          setContentType(value);
        }}
        onBlur={() => runValidationTasks("contentType", contentType)}
        errorMessage={errors.contentType?.errorMessage}
        hasError={errors.contentType?.hasError}
        {...getOverrideProps(overrides, "contentType")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              actors,
              awards,
              boxOffice,
              country,
              director,
              dvd,
              genre,
              imdbId,
              imdbRating,
              imdbVotes,
              language,
              metaScore,
              plot,
              poster,
              production,
              rated,
              released,
              runtime,
              title,
              rottenTomatoConsensus,
              rottenTomatoFresh,
              rottenTomatoImage,
              rottenTomatoMeter,
              rottenTomatoRating,
              rottenTomatoReviews,
              rottenTomatoRotten,
              rottenTomatoUrl,
              rottenTomatoUserMeter,
              rottenTomatoUserRating,
              rottenTomatoUserReviews,
              type,
              website,
              writer,
              year,
              contentType,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
